import React, { Component } from 'react';
import { Grid } from '@mui/material';
import Utube from './Api/Utube';
// import SearchBar from './Components/SearchBar'
import { SearchBar, VideoDetails, VideoList  } from './Components';
import Logo from "./Icons/Logo";
import "./Components/Styles/Body.css";

class App extends Component {
    state = {
        videos: [],
        selectedVideo: null,
    }
    componentDidMount(){
        this.handleSubmit("ASPHALT 8: AIRBORNE - Bugatti Chiron")
    };

    handleSubmit = async (searchTerm) =>{
        const response = await Utube.get('/search', {
            params: {
                q: searchTerm
            }});
        // console.table(response.data.items);
        this.setState({videos: response.data.items, selectedVideo:response.data.items[0] })
    }

    

    onVideoSelect =(video)=>{
        this.setState({selectedVideo: video});
    }


    render() {

        const { selectedVideo, videos } = this.state;

        return (
            <>
                <Grid container >
                    <Grid item lg={12}>
                            <Grid container className="navbar" elevation={10}>
                                <Grid item lg={2} className='logo_div'>
                                    <Logo />
                                </Grid>
                                <Grid item lg={7}>
                                    <SearchBar onFormSubmit={this.handleSubmit} />
                                </Grid>
                                <Grid item lg={3}>
                                    {/* account */}
                                </Grid>
                            </Grid>
                        <Grid container className='rest_body'>
                            <Grid item lg={8} className='main_video_div'>
                                <VideoDetails video={selectedVideo}/>
                            </Grid>
                            <Grid item lg={4} className='video_list_div'>
                                <VideoList videos={videos} onVideoSelect={this.onVideoSelect} />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </>
        )
    }
}
export default App
